import React, { memo } from 'react';
import { Handle, Position } from 'react-flow-renderer';

const ApiNode = ({ data, isConnectable }) => {
  return (
    <div className="node node-api">
      <Handle type="target" position={Position.Top} isConnectable={isConnectable} />
      <div>
        <h4>{data.label}</h4>
        {data.apiEndpoint && <p>API: {data.apiEndpoint}</p>}
        {data.payload && (
          <p>
            Payload: {Object.keys(data.payload).length} field(s)
          </p>
        )}
      </div>
      <Handle type="source" position={Position.Bottom} isConnectable={isConnectable} />
    </div>
  );
};

export default memo(ApiNode); 